import { render, staticRenderFns } from "./EmptyContainer.vue?vue&type=template&id=a21ec9ea&"
import script from "./EmptyContainer.vue?vue&type=script&lang=ts&"
export * from "./EmptyContainer.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports